import { scrollToTop } from "@/utils";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import ScrollToTopButton from "./ScrollToTopButton";

const CopyRightSocial = () => {
  return (
    <div className="border-t border-white/10 bg-slate-950">
      <div className="container mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-3 sm:gap-4 text-center lg:text-left">
          {/* Copyright & Legal links */}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-gray-400 text-xs sm:text-sm">
            <span>© {new Date().getFullYear()} Église de Dieu de Garizim.</span>
            <span className="hidden sm:inline text-gray-600">•</span>
            <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-gray-400">
              <Link
                to="/politique-de-confidentialite"
                onClick={() => scrollToTop()}
                className="hover:text-amber-300 transition-colors underline"
              >
                Politique de Confidentialité
              </Link>
              <span className="text-gray-600">|</span>
              <Link
                to="/conditions-utilisation"
                onClick={() => scrollToTop()}
                className="hover:text-amber-300 transition-colors underline"
              >
                Conditions d'Utilisation
              </Link>
              <span className="text-gray-600">|</span>
              <Link
                to="/a-propos"
                onClick={() => scrollToTop()}
                className="hover:text-amber-300 transition-colors underline"
              >
                À Propos
              </Link>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="flex flex-wrap items-center justify-center gap-1.5 sm:gap-2">
            <a
              href="https://www.facebook.com/eglisegarizim/?locale=fr_CA"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/5 hover:bg-blue-600/20 hover:text-blue-400 border border-white/10 text-gray-300 transition-all text-xs font-medium"
              aria-label="Facebook Église Garizim"
              title="Facebook Église"
            >
              <Facebook className="w-4 h-4 text-blue-400 shrink-0" />
              <span className="hidden sm:inline">Facebook</span>
            </a>
            <a
              href="https://www.facebook.com/jeunesse.garizim"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/5 hover:bg-blue-600/20 hover:text-blue-400 border border-white/10 text-gray-300 transition-all text-xs font-medium"
              aria-label="Facebook Jeunesse Garizim"
              title="Facebook Jeunesse"
            >
              <Facebook className="w-4 h-4 text-blue-400 shrink-0" />
              <span className="text-[11px] sm:text-xs text-amber-300 font-semibold">
                Jeunesse
              </span>
            </a>
            <a
              href="https://www.instagram.com/eddgarizim/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/5 hover:bg-pink-600/20 hover:text-pink-400 border border-white/10 text-gray-300 transition-all text-xs font-medium"
              aria-label="Instagram Église Garizim"
              title="Instagram Église"
            >
              <Instagram className="w-4 h-4 text-pink-400 shrink-0" />
              <span className="hidden sm:inline">Instagram</span>
            </a>
            <a
              href="https://www.instagram.com/jeunessedegarizim"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/5 hover:bg-pink-600/20 hover:text-pink-400 border border-white/10 text-gray-300 transition-all text-xs font-medium"
              aria-label="Instagram Jeunesse Garizim"
              title="Instagram Jeunesse"
            >
              <Instagram className="w-4 h-4 text-pink-400 shrink-0" />
              <span className="text-[11px] sm:text-xs text-amber-300 font-semibold">
                Jeunesse
              </span>
            </a>
            <a
              href="https://www.youtube.com/@eglisegarizim1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/5 hover:bg-red-600/20 hover:text-red-400 border border-white/10 text-gray-300 transition-all text-xs font-medium"
              aria-label="YouTube Église Garizim"
              title="YouTube"
            >
              <Youtube className="w-4 h-4 text-red-500 shrink-0" />
              <span className="hidden sm:inline">YouTube</span>
            </a>
          </div>

          <a
            href="https://www.paypal.com/donate?hosted_button_id=LPCZP88RDTNK4"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 bg-church-gold-500 hover:bg-church-gold-600 text-black font-semibold px-3.5 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm transition-colors duration-200 shadow shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-black"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" />
            </svg>
            Don Paypal
          </a>
        </div>
      </div>

      <ScrollToTopButton />
    </div>
  );
};

export default CopyRightSocial;
